import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiClientService } from '../../core/api/api-client.service';
import { AuthService } from '../../core/auth/auth.service';
import { ThemeService } from '../../core/theme/theme.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './login-page.component.html'
})
export class LoginPageComponent {
  private readonly auth = inject(AuthService);
  private readonly api = inject(ApiClientService);
  private readonly router = inject(Router);
  private readonly theme = inject(ThemeService);

  protected readonly form = new FormGroup({
    email: new FormControl('admin@driveme.local', {
      nonNullable: true,
      validators: [Validators.required, Validators.email]
    }),
    password: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    rememberMe: new FormControl(true, { nonNullable: true })
  });

  protected readonly error = signal<string | null>(null);
  protected readonly loading = signal(false);
  protected readonly submitted = signal(false);
  protected readonly showPassword = signal(false);
  protected readonly currentSkin = this.theme.currentSkin;

  toggleSkin(): void {
    this.theme.setSkin(this.currentSkin() === 'modern-premium' ? 'technical-precision' : 'modern-premium');
  }

  togglePasswordVisibility(): void {
    this.showPassword.update((value) => !value);
  }

  submit(): void {
    this.submitted.set(true);

    if (this.loading()) {
      return;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.error.set('Bitte E-Mail und Passwort ausfüllen.');
      return;
    }

    this.error.set(null);
    this.loading.set(true);
    const { email, password, rememberMe } = this.form.getRawValue();

    this.api.login({ email, password }).subscribe({
      next: (response) => {
        this.auth.setToken(response.token, rememberMe);
        this.auth.setCurrentUser(response.user, rememberMe);
        this.router.navigateByUrl(response.user.role === 'DRIVER' ? '/learning' : '/dashboard');
      },
      error: () => {
        this.error.set('E-Mail oder Passwort ist falsch.');
        this.auth.logout();
        this.loading.set(false);
      },
      complete: () => {
        this.loading.set(false);
      }
    });
  }
}
